<template>
  <import-tab>
    <template v-slot:form>
      <div class="w-full flex flex-col items-center">
        <app-datepicker
          :class="$style.date"
          v-model="uploadMonth"
          format="MMMM yyyy"
          minimum-view="month"
          label="Месяц"
        />

        <vs-upload
          ref="uploader"
          action="#"
          :limit="1"
          :show-upload-button="false"
          text="Загрузить файл"
          @change="changeFiles"
          @on-delete="deleteFiles"
          class="w-auto mx-auto"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
        <vs-button type="border" color="success" @click="importDevicesValues">Загрузить</vs-button>
        <div class="w-full text-center mt-4">
          <p>Формат файла - xls, xlsx, csv.</p>
        </div>
      </div>
    </template>

    <template v-slot:history>
      <vs-table
        v-if="history"
        :data="history"
        max-items="5"
        pagination class="w-full"
        noDataText="История импорта пуста"
      >
        <template slot="thead">
          <vs-th>Дата</vs-th>
          <vs-th>Автор</vs-th>
          <vs-th>Имя файла</vs-th>
          <vs-th>Скачать</vs-th>
          <vs-th />
        </template>

        <template slot-scope="{data}" ref="content">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ tr.created_at | moment('DD.MM.YYYY HH:mm:ss') }}
            </vs-td>
            <vs-td>
              <span v-if="tr.user">{{ tr.user.name }}</span>
            </vs-td>
            <vs-td>
              <div style="max-width: 200px; white-space: normal; word-break: break-word;">
                {{ tr.name }}
              </div>
            </vs-td>
            <vs-td>
              <a :href="tr.path | imgPath" :download="tr.name" target="_blank">
                <feather-icon icon="DownloadIcon" svg-classes="text-primary" class="cursor-pointer" />
              </a>
            </vs-td>
            <vs-td>
              <a href="#" @click.prevent="onOpenLog(tr.log)" v-if="tr.log">подробнее</a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-popup :title="popupTitle" :active.sync="popupOpen">
        <h5 class="mb-4 flex items-center">
          <feather-icon icon="CheckCircleIcon" class="mr-4" svg-classes="text-success" />
          Всего добавлено: {{ popupData.successAdded }}
        </h5>
        <h5 class="mb-4 flex items-center">
          <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger" />
          Апартаментов не найдено: {{ popupData.errorNoApartment }}
        </h5>
        <h5 class="mb-4 flex items-center">
          <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger" />
          Приборов не найдено: {{ popupData.errorNoDevice }}
        </h5>
        <h5 class="mb-4 flex items-center">
          <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger" />
          Количество приборов одного типа: {{ popupData.errorManyDevices }}
        </h5>
      </vs-popup>
    </template>
  </import-tab>
</template>

<script>
import ImportTab from "./ImportTab";

export default {
  name:       "ImportDevice345Apartments",
  components: {
    ImportTab,
  },
  props:      ['selectedHouseId'],
  data() {
    return {
      history:     null,
      uploadMonth: new Date(),
      uploadFile:  null,

      popupTitle: null,
      popupOpen:  false,
      popupData:  {},
    };
  },
  methods:    {
    loadHistory() {
      const params = { buildings_id: this.selectedHouseId };
      this.$http.get('import/history/device345Apartments', { params }).then(( { data: { files } } ) => {
        this.history = files;
      });
    },
    onUpload( data ) {
      this.popupTitle = 'Импорт завершен';
      this.popupOpen = true;
      this.popupData = data;
      this.loadHistory();
    },
    onOpenLog( log ) {
      this.popupTitle = "Информация о импорте";
      this.popupOpen = true;
      this.popupData = log;
    },

    changeFiles( event, files ) {
      this.uploadFile = files[files.length - 1];
    },
    deleteFiles() {
      this.uploadFile = null;
    },
    async importDevicesValues() {
      if (!this.uploadFile || !this.uploadMonth) return;
      let body = new FormData();
      body.append('devices_file', this.uploadFile);
      body.append('buildings_id', this.selectedHouseId);
      body.append('users_id', this.$store.getters['appUser/id']);
      body.append('month', this.$options.filters.moment(this.uploadMonth, 'YYYY-MM'));
      this.$vs.loading({ type: 'default' });
      try {
        let { data } = await this.$http.post('import/device345_apartments', body);
        if (data === 'error' || data.message === 'error') {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Файл не загружен' });
        } else if (data === 'denied') {
          this.$vs.notify({
            color: 'danger',
            title: 'Ошибка загрузки',
            text:  'На данный месяц уже показаны квитанции',
          });
        } else {
          this.onUpload(data);
          this.$vs.notify({ color: 'success', title: 'Импорт завершен', text: 'Файл импортирован' });
          this.resetFile();
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      } finally {
        this.$vs.loading.close();
      }
    },

    resetFile() {
      this.uploadFile = null;
      this.$refs.uploader.srcs = [];
      this.$refs.uploader.itemRemove = [];
      this.$refs.uploader.filesx = [];
    },
  },
  mounted() {
    this.loadHistory();
  },
  watch:      {
    selectedHouseId() {
      this.loadHistory();
    },
  },
};
</script>

<style module>
.date {
  width: 160px;
  margin: 0 auto;
}
</style>
